export const GTM_APP_NAME = "autotrack-frontend";
export const GTM_ID = "GTM-T9KJSWC";
